export default __webpack_public_path__ + "static/media/contact-icon.7a529431.svg";